package com.exura.ui.modifiers

import com.exura.ui.Dimens
import com.exura.ui.ExuraColors
import com.exura.ui.ExuraRgba
import com.varabyte.kobweb.compose.css.BoxShadow
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times


fun getBorderBoxShadow(
    border: ShadeBorder,
    shadeSize: CSSLengthNumericValue = 8.px,
    shadeIntensity: Double = 0.7,
    shadeColor: ExuraRgba = ExuraColors.BLACK.copy(alpha = 0.05),
    inset: Boolean = true,
) = when (border) {
    ShadeBorder.TOP -> BoxShadow.of(
        inset = inset,
        offsetY = shadeSize,
        offsetX = Dimens.spacingNone,
        blurRadius = shadeSize,
        spreadRadius = if (inset) (-1) * shadeSize * (1 - shadeIntensity) else shadeSize * shadeIntensity,
        color = shadeColor.rgba,
    )
    ShadeBorder.BOTTOM -> BoxShadow.of(
        inset = true,
        offsetY = (-1) * shadeSize,
        offsetX = Dimens.spacingNone,
        blurRadius = shadeIntensity * shadeSize,
        spreadRadius = if (inset) (-1) * shadeSize * (1 - shadeIntensity) else shadeSize * shadeIntensity,
        color = shadeColor.rgba,
    )
    ShadeBorder.RIGHT -> BoxShadow.of(
        inset = true,
        offsetY = Dimens.spacingNone,
        offsetX = (-1) * shadeSize,
        blurRadius = shadeIntensity * shadeSize,
        spreadRadius = if (inset) (-1) * shadeSize * (1 - shadeIntensity) else shadeSize * shadeIntensity,
        color = shadeColor.rgba,
    )
    ShadeBorder.LEFT -> BoxShadow.of(
        inset = true,
        offsetY = Dimens.spacingNone,
        offsetX = shadeSize,
        blurRadius = shadeSize,
        spreadRadius = if (inset) (-1) * shadeSize * (1 - shadeIntensity) else shadeSize * shadeIntensity,
        color = shadeColor.rgba,
    )
}
